import { ReactComponent as HeadlinerTextLogo } from 'assets/icons/headliner-text-only.svg';

export default HeadlinerTextLogo;
